import { render, staticRenderFns } from "./SitemapMainLinkTopic.vue?vue&type=template&id=82aba7e8&"
import script from "./SitemapMainLinkTopic.vue?vue&type=script&lang=js&"
export * from "./SitemapMainLinkTopic.vue?vue&type=script&lang=js&"
import style0 from "./SitemapMainLinkTopic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports